// extracted by mini-css-extract-plugin
export default {"root":"Kzoct","icon":"YGEJQ","title":"JYK2u","buttonsContainer":"G4W_U","spinner":"DEW6f"};